import * as React from 'react';
import linkifyIt from 'linkify-it';
import tlds from 'tlds';
import Link from './Link/Link';
import { defaultTheme } from './theme.js';

export default (config = {}) => {
  // Styles are overwritten instead of merged as merging causes a lot of confusion.

  // Why? Because when merging a developer needs to know all of the underlying
  // styles which needs a deep dive into the code. Merging also makes it prone to
  // errors when upgrading as basically every styling change would become a major
  // breaking change. 1px of an increased padding can break a whole layout.

  const {
    component,
    theme = defaultTheme,
    target = '_self',
    rel = 'noreferrer noopener',
    fuzzyLink = true,
  } = config;

  const linkify = linkifyIt();
  linkify.tlds(tlds);
  linkify.set({ fuzzyLink });

  const linkifyStrategy = (contentBlock, callback) => {
    const links = linkify.match(contentBlock.get('text'));
    if (typeof links !== 'undefined' && links !== null) {
      for (let i = 0; i < links.length; i += 1) {
        callback(links[i].index, links[i].lastIndex);
      }
    }
  };

  const DecoratedLink = (props) => (
    <Link {...props} theme={theme} target={target} rel={rel} component={component} />
  );

  return {
    decorators: [
      {
        strategy: linkifyStrategy,
        component: DecoratedLink,
      },
    ],
  };
};
